import * as React from 'react';

import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/browse';

import 'css!bundles/accomplishments/components/shared/__styles__/CertificateImage';

type Props = {
  certificateImageUrl?: string;
  itemName: string;
  certificatePdfPageLink: string;
  isCertificateOwner?: boolean;
  userName: string;
  universityNames?: string;
  certificateDescription?: string;
  isSpecialization?: boolean;
};

const CertificateImage = ({
  userName,
  certificateImageUrl,
  certificatePdfPageLink,
  itemName,
  isCertificateOwner,
  universityNames,
  certificateDescription,
  isSpecialization = false,
}: Props) => {
  const altText = isSpecialization
    ? _t('View certificate for #{userName}, #{itemName}, offered through Coursera. #{certificateDescription}', {
        userName,
        itemName,
        certificateDescription,
      })
    : _t(
        'View certificate for #{userName}, #{itemName}, an online non-credit course authorized by #{universityNames} and offered through Coursera',
        { userName, itemName, universityNames }
      );

  if (!certificateImageUrl) {
    return null;
  }

  if (!isCertificateOwner) {
    return (
      <div className="rc-CertificateImage">
        <img src={certificateImageUrl} alt={altText} />
      </div>
    );
  } else {
    return (
      <TrackedA
        href={certificatePdfPageLink}
        trackingName="certificate_image_link"
        className="rc-CertificateImage"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={certificateImageUrl} alt={altText} />
      </TrackedA>
    );
  }
};

export default CertificateImage;
